import { useContext, useState } from 'react';
import PrimeiroAdquirenteListaProcessos from './primeiroAdquirenteListaProcessos/primeiroAdquirenteListaProcessos';
import PrimeiroAdquirenteNovaAquisicao from './primeiroAdquirenteNovaAquisicao/primeiroAdquirenteNovaAquisicao';
import { IAquisicao } from '../../../../interfaces/IAquisicao';
import { DiefCfemContext } from '../../../../contexts/DiefCfemContext';
import { useBackEndRequests } from '../../lib/backEndRequests';
import { useNotificacao } from '../../../../hooks/useNotificacao';

interface IPrimeiroAdquirentNovaAquisicaoProps {
  isNovaAquisicao: boolean;
  setNovaAquisicao: React.Dispatch<React.SetStateAction<boolean>>;
}

function PrimeiroAdquirenteProcessoMinerario({
  isNovaAquisicao,
  setNovaAquisicao,
}: IPrimeiroAdquirentNovaAquisicaoProps) {
  const [edicaoAquisicao, setEdicaoAquisicao] = useState<IAquisicao>();

  const { postSalvarRascunhoDeclaracao } = useBackEndRequests();

  const context = useContext(DiefCfemContext);
  const declaracaoPrimeiroAdquirente = context?.declaracaoPrimeiroAdquirente;

  const mostrarNotificacao = useNotificacao();

  const salvarRascunho = async () => {
    if (declaracaoPrimeiroAdquirente)
      await postSalvarRascunhoDeclaracao(declaracaoPrimeiroAdquirente).catch((err) =>
        mostrarNotificacao({
          tipo: 'danger',
          conteudo: 'Erro ao salvar rascunho',
          ...(err && { complementoSentryId: err }),
        })
      );
    else
      mostrarNotificacao({
        tipo: 'danger',
        conteudo: 'Erro ao salvar rascunho',
      });
  };

  return (
    <>
      {isNovaAquisicao ? (
        <PrimeiroAdquirenteNovaAquisicao
          setNovaAquisicao={setNovaAquisicao}
          edicaoAquisicao={edicaoAquisicao}
          setEdicaoAquisicao={setEdicaoAquisicao}
          salvarRascunho={salvarRascunho}
        />
      ) : (
        <PrimeiroAdquirenteListaProcessos setNovaAquisicao={setNovaAquisicao} setEdicaoAquisicao={setEdicaoAquisicao} />
      )}
    </>
  );
}

export default PrimeiroAdquirenteProcessoMinerario;
